import { useCallback, useEffect, useRef, useState } from 'react'
import SearchBar from '../../../baseComponents/SearchBar'
import { twinFetchPostJSON } from '../../../utils/globals/data'
import useOnClickOutside from '../../../utils/hooks/useOnClickOut'
import { ProductExtendedTyShort } from '../types'
import SearchBarProductResults from './SearchBarProductResults'
import { OnChangeSearchBarAddProduct } from './types'
import './searchbarproduct.sass'

interface SearchBarProductProps extends SearchBarProductLogicProps {
    name: string
    title?: string
    className?: string
    placeholder?: string
}

const SearchBarProduct: React.FC<SearchBarProductProps> = ({ name, title, className, placeholder, ...rest }) => {
    const { setSearchValue, items, searchValue, ref, myChangeSelectedItems } = useSearchBarProductLogic({ ...rest })
    return (
        <div className={'relative ' + (className || '')} ref={ref}>
            {title && <span className='block regular18 my-22'>
                {title}
            </span>}
            <SearchBar onChange={setSearchValue} {...{ searchValue, placeholder }} />
            {items && <SearchBarProductResults products={items} onSelectProduct={myChangeSelectedItems} className='w-full' />}
        </div>
    )
}

interface SearchBarProductLogicProps {
    url: string
    id: string,
    excludeIds?: string[] | number[]
    where?: any
    fieldNotIn?: string
    changeSelectedItems: OnChangeSearchBarAddProduct
    order?: string[][]
}

const useSearchBarProductLogic = ({ url, id, excludeIds, where, fieldNotIn, changeSelectedItems, order }: SearchBarProductLogicProps) => {
    const ref = useRef<any>(null)
    const [searchValue, setSearchValue] = useState<string>('')
    const [items, setItems] = useState<ProductExtendedTyShort[] | null>(null)

    const resetSearchValue = useCallback(() => {
        setSearchValue('')
        setItems(null)
    }, [setSearchValue])

    const myChangeSelectedItems: OnChangeSearchBarAddProduct = useCallback((value) => {
        changeSelectedItems(value)
        resetSearchValue()
    }, [changeSelectedItems, resetSearchValue])

    const searchItems = useCallback(async (value: string) => {
        if (fieldNotIn) {
            let excludedIdsExists: any[] = []
            if (excludeIds) {
                excludedIdsExists = [...excludeIds]
            }
            if (id !== '') {
                excludedIdsExists = [parseInt(id), ...excludedIdsExists]
            }
            where[fieldNotIn] = {
                '$not': [...excludedIdsExists]
            }
        }
        const searchedItems = await twinFetchPostJSON(url, {
            attributes: ['id', 'reference', 'ProductLangs.name', 'ProductImages.url'],
            where:
            {
                '$or': {
                    'reference': { '$iLike': `%${value}%` },
                    'ProductLangs.name': { '$iLike': `%${value}%` }
                },
                ...where
            },
            order,
            limit: 15
        })
        setItems(searchedItems)
    }, [url, setItems, id, excludeIds, where, fieldNotIn, order])


    useOnClickOutside(ref, () => resetSearchValue())


    useEffect(() => {
        if (searchValue !== '') {
            searchItems(searchValue)
        } else {
            setItems(null)
        }
    }, [searchValue, searchItems])

    return { setSearchValue, items, searchValue, resetSearchValue, ref, myChangeSelectedItems }
}

export default SearchBarProduct